export default __webpack_public_path__ + "static/media/marketing_angles.79bc6332.svg";